import { withStyles } from '../../tools/withStyles';
import { Component } from './Template';
import { styles } from './Template.styles';

const Template = withStyles(styles)(Component);

export default Template;

// Commit trace: 2025-09-13T05:56:33 - perf: improve memory usage in index.js

// Commit trace: 2025-10-28T04:30:13 - docs: clarify parameter types in index.js
